import { Component, OnInit, Directive, ElementRef, Input, forwardRef, ContentChild, TemplateRef, ViewChild, EventEmitter, Output, OnDestroy } from '@angular/core';
import { Subject, from, Subscription, throwError, of } from 'rxjs';
import { SelectDataSource } from './select-data-source';
import { HttpClient } from '@angular/common/http';
import { tap, switchMap, finalize, catchError, map, delay } from 'rxjs/operators';
import { SelectQuery } from './select-query';
import { SelectResult } from './select-result';
import { NG_VALUE_ACCESSOR, ControlValueAccessor, FormBuilder, FormGroup, UntypedFormGroup } from '@angular/forms';
import { TooltipComponent } from '@syncfusion/ej2-angular-popups';
import { NgSelectComponent } from '@ng-select/ng-select';


@Directive({
  selector: '[axAutoFocus]'
})
export class AxAutoFocusDirective implements OnInit {
  constructor(private el: ElementRef) { }

  ngOnInit() {
    this.el.nativeElement.focus();
  }

}

@Directive({
  selector: '[axLabelTemplate]'
})
export class AxLabelTemplateDirective {
  constructor() { }
} 

@Directive({
  selector: '[axLabelValueTemplate]'
})
export class AxLabelValueTemplate {
  constructor() { }
} 

@Directive({
  selector: '[axOptionTemplate]'
})
export class AxOptionTemplateDirective {
  constructor() { }
} 


enum SelectMode {
  ARRAY,
  REMOTE
}


/**
 * Se dataSource mudar durante a vida útil do componente utilizar o evento onDataSourceConfigured para
 * setar possível valor padrão, pois não tem como detectar qual sera setado primeiro (o datasouce ou o value) e
 * o evento onDataSourceConfigured é chamado quando o ds já foi configurado (se o ds é array local a array já terá sido iniciada).
 * 
 * Em caso de setar o ds uma vez durante toda a vida útil do componente, então basta alterar o value, para ds remoto o componente
 * busca o valor no servidor.
 * 
 * 
 */
@Component({
  selector: 'ax-select',
  templateUrl: './ax-select.component.html',
  styleUrls: ['./ax-select.component.less'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AxSelectComponent),
      multi: true,
    },
  ],
  host: {'class': 'ax-select'}
})
export class AxSelectComponent implements OnInit, OnDestroy, ControlValueAccessor {
  @ContentChild(AxLabelTemplateDirective, { read: TemplateRef }) 
  labelTemplate: TemplateRef<any> | null = null;
  @ContentChild(AxOptionTemplateDirective, { read: TemplateRef }) 
  optionTemplate: TemplateRef<any> | null = null;//

  fromWrite: boolean = false;

  model: UntypedFormGroup = this.fb.group({
    value: [null]
  });

  dsOriginalItems: Object[] = [];
  dsItems: Object[] = [];

  private firstSet: boolean = true;

  private mode: SelectMode | null = null;

  private init: boolean  = false;

  hasError: boolean = false;
  hasMore: boolean = true;
  loading: boolean = false;
  firstLoad: boolean = false;
  loadingDefaults: boolean = false;
  filter$: Subject<string> = new Subject<string>();
  defaults: Subject<any> = new Subject<any>();

  _dataSource: SelectDataSource | any[] = new SelectDataSource();
  hasDataSourceAttached: boolean = false;

  emitChange: any;

  subDefaults: Subscription | null = null;
  subFilter: Subscription | null  = null;

  // Quando ds ou init ainda não foi inicializado salva o valor em _valueTmp;
  _idTmp: Object | null = null;

  _value: Object | null  = null;

   tooltipText: string = '';

  @ViewChild('tooltip')
  tooltip: TooltipComponent | null = null;

  set value(v: Object | null) {
    this.log('SETA VALUE');

    if(this.loadingDefaults)
      return;


    if(v)
      this.tooltipText = (v as any)?.text ?? '';
    else 
      this.tooltipText = '';

      this.log(v);
    this.valueChanged(v, false);
  }

  get value(): Object | null {
    return this._value;
  }

  @Output()
  onDataSourceConfigured: EventEmitter<string> = new EventEmitter<string>();
  
  @Input()
  appendTo: string = '';
  
  @Input() 
  enabled: boolean = true;
  @Input() 
  debug: boolean = false;
  @Input() 
  label: string = '';
  @Input() 
  id: string = '';
  @Input() 
  placeholder: string = '';
  @Input()
  clearable: boolean = false;
  @Input()
  searchable: boolean = true;
  @Input() 
  name: string = '';

  _multiple: boolean = false;

  subs: Subscription[] = [];

  @Input() 
  set multiple(v: boolean) {
    this._multiple = v;

    if(this.init)
      this.value = null; 
  }

  get multiple(): boolean {
    return this._multiple;
  }

  @Input()
  set dataSource(v: SelectDataSource | any[] | null) {

    this.hasError = false;
    this.loading = false;
    this.loadingDefaults = false;

    if(!v) {
      this.hasDataSourceAttached = false;
      return;
    }

    this._dataSource = v;
    this.hasDataSourceAttached = true;

    if (Array.isArray(v)) {
      this.mode = SelectMode.ARRAY;
      this.dsOriginalItems = v;
      this.dsItems = v;
    } else {
      this.mode = SelectMode.REMOTE;
      this.dsOriginalItems = [];
      this.dsItems = [];
      v.query.page = 0;
      v.query.term = '';
    }

    this.onDataSourceConfigured.next(this.id);

    this.fromWrite = true;
    
    this.log("DATASOURCE");
    this.logJson(this.model.get('value')?.value ?? null);

    // Cada vez que muda o ds.
    if((this.model.get('value')?.value ?? null) === null) {
      this.searchAndSetValue(null);
    } else {
      this.searchAndSetValue(this.model.get('value')?.value ?? null);
    }

    //this.valueChanged((this._value as any).id, true);

    return;

    /*if(this.init) {
      if (this._idTmp !== null) {
        // _idTmp é sempre o id de um objeto do tipo { id: ... text: ... }, esse objeto pode ter
        // mais fields opcionais, mas id e text é obrigatório.
        this.valueChanged(this._idTmp, true);
        return;
      }

      if (this._value !== null) {
        // _value quando salvo sempre é um objeto do tipo { id: ... text: ... }.
        this.valueChanged((this._value as any).id, true);
        return;
      }
    }*/
  }

  get dataSource(): SelectDataSource | any[] {
    return this._dataSource;
  }

  constructor(private http: HttpClient, private fb: FormBuilder ) { }

  ngOnDestroy(): void {
    this.subs.forEach((v: Subscription) => v.unsubscribe());
  }
 
  ex: boolean = false;
  val: object | null = null;

  @ViewChild('inputX')
  inputX: ElementRef<HTMLInputElement> | null = null;

  @ViewChild('select')
  ngselect!:  NgSelectComponent;

  ngOnInit() {
    this.init = true;

    this.subs[this.subs.length] = this.model.get('value')!.valueChanges
    .pipe(
      tap((v) => {
        // Para validação do grid syncfusion detectar mudança no input quando algo for selecionado no dropdown.
        this.val  = v;
        this.inputX?.nativeElement.focus();
        setTimeout(() => {
          this.ngselect.focus();
        }, 50);
      }),
      switchMap((v: any) => of(v))
    )
    .subscribe((v: any) => {
      if(Array.isArray(v)) {
        let ids: any[] | null = [];

        v.forEach((v: any) => ids?.push(v.id));

        if(ids?.length === 0)
          ids = null;

        this.emitChange?.call(this, ids);
      }
      else {
        if(v !== null)
          this.emitChange?.call(this, (v as any).id);
        else
          this.emitChange?.call(this, null);
      } 
    });

    // Configura filter subject.
    this.subFilter = this.filter$
      .pipe(
        tap((term: string) => {
          this.loading = true;
          this.hasMore = true;
        }),
        switchMap((term: string) => {
          if (!Array.isArray(this.dataSource)) {

            let query: SelectQuery<any> = this.dataSource.query;
            let url: string = this.dataSource.url;

            query.page = 0;
            query.term = term;
            query.discover = false;

            return this.http.post<SelectResult>(url, query, {
              headers: { ignoreLoadingBar: '' }
            });

          } else {
            return from([{
              results: this.dsOriginalItems.filter((v: Object) => {
                return ((v as any).text as string)
                .toLowerCase()
                .normalize("NFD").replace(/\p{Diacritic}/gu, "")
                .includes(term?.toLowerCase()?.normalize("NFD")?.replace(/\p{Diacritic}/gu, "") ?? '');
              })
            }
            ]);
          }

        }),
        tap((x: any) => {
          if (!Array.isArray(this._dataSource)) {
            this.hasMore = x.pagination.more === true;
          }
        }),
        catchError((err: any) => {
          if (!Array.isArray(this._dataSource)) {
            this._dataSource.query.page = 0;
            this._dataSource.query.term = '';
          }

          this.dsItems = [];
          this.hasError = true;
          this.hasMore = false;
          this.loading = false;
          
          this.log(err);

          return throwError(err)
        }),
        tap(() => {
          this.loading = false;
        })
      )
      .subscribe((r: SelectResult) => {
        this.hasError = false;
        this.dsItems = r.results;
        this.loading = false;
      });

      // Configura defaults subject.
      this.subDefaults = this.defaults
      .pipe(
        tap((ids: any) => {
          this.loadingDefaults = true;
          this.loading = true;
        }),
        switchMap((ids) => {
          if (!Array.isArray(this._dataSource)) {

            let query: SelectQuery<any> = this._dataSource.query;
            let url: string = this._dataSource.url;

            query.ids = ids;
            query.discover = true;

            return this.http.post<SelectResult>(url, query, {
              headers: { ignoreLoadingBar: '' }
            });
          } 

          return of(null);
        }),
        catchError((err: any) => {
          if (!Array.isArray(this._dataSource)) {
            this._dataSource.query.page = 0;
            this._dataSource.query.term = '';
          }

          this.dsItems = [];
          this.hasError = true;
          this.hasMore = false;
          this.loading = false;
          this.loadingDefaults = false;

          throw err
        }),
        tap(() => {
          this.loading = false;
          this.loadingDefaults = false;
          this._idTmp = null;

          this.log("VALUE TEP NULLED");

        })
      )
      .subscribe((r: SelectResult | null) => {
        this.log("DEFAULTS RESULT");
        this.logJson(r);

        if(r?.results.length === 0)
          this.model.get('value')?.setValue(null, { emitEvent: false });
        else {
          if(!this.multiple) {
            this.model.get('value')?.setValue(r?.results[0], { emitEvent: false }); //!!!!!!!
          }
          else {
            this.model.get('value')?.setValue(r?.results, { emitEvent: false });
          }
        }

        if (this.dsItems.length === 0) {
          // Se não tem nada carregado ainda, então carrega página 0.
          this.loadRemoteItems(0);
        }

        this.hasError = false;
      });


      //if (this._idTmp !== null) {
        // Se tem valor temporario salvo, chanve valueChanged para atualizar value.
        //this.valueChanged(this._idTmp, true);
        //return;
      //}
  }

  loadRemoteItems(page: number, ids: Object[] | null = null) {
    this.loading = true;

    if (Array.isArray(this._dataSource))
      return;

    let query: SelectQuery<any> = this._dataSource.query;
    let url: string = this._dataSource.url;

    query.page = page;
    query.ids = null;
    query.discover = false;

    this.http.post<SelectResult>(url, query, {
      headers: { ignoreLoadingBar: '' }
    })
      .pipe(
        tap((x: any) => {
          this.hasMore = x.pagination.more === true;
        }),
        catchError(() => {
          if (Array.isArray(this._dataSource))
            return [];

          this._dataSource.query.page = 0;
          this._dataSource.query.term = '';
          this.hasMore = false;
          this.hasError = true;
          this.dsItems = [];
          this.loading = false;

          return [];
        }),
        finalize(() => {
          this.loading = false;
        })
      )
      .subscribe((r: SelectResult) => {

        this.dsItems = this.dsItems.concat(r.results);
        this.loading = false;
        this.hasError = false;

        this.log("LOADED");
      });
  }

  onScrollToEnd() {

    if (!this.hasMore || this.mode === SelectMode.ARRAY)
      return;

    if (!Array.isArray(this.dataSource)) {
      this.dataSource.query.page += 1;
      this.loadRemoteItems(this.dataSource.query.page);
    }
  }

  onScroll(end: any) {
    if (this.loading || !this.hasMore || this.mode === SelectMode.ARRAY)
      return;

    if ((end) >= (this.dsItems.length - 250 - 1)) {
      if (!Array.isArray(this.dataSource)) {
        this.dataSource.query.page += 1;
        this.loadRemoteItems(this.dataSource.query.page);
      }
    }
  }

  onOpen() {
    if (this.hasError) {
      // Se está marcado que ocorreu algum erro
      // reinicia componente.

      if(this.subDefaults)
        this.subDefaults.unsubscribe();

      if(this.subFilter)
        this.subFilter.unsubscribe();

      this.defaults = new Subject<any>();
      this.filter$ = new Subject<string>();

      this.ngOnInit();

      this.loadRemoteItems(0);
      
    } else {
      if(this.dsItems.length === 0 && !Array.isArray(this.dataSource)) {
        this.loadRemoteItems(0);
      }
    }

  }

  valueChanged(v: Object | null, remoteSearch: boolean): void {
    this.log("valueChanged = " + v);

    // Se datasource esta null ou init ainda nao cocorreu, não faz nenhuma alteração no value, espera até ser inicializado.
    if (this.dataSource == null || this.init === false) {
      // Salva tmp para quando datasource for inicializado.
      this._idTmp = v;
      return;
    }

    if (!remoteSearch) {

      if(this.fromWrite) {
        // Se from write não emite change.
        this._value = v;
        this.firstSet = false;
        this.fromWrite = false;
        return;
      }

      // Se a setagem esta vindo do próprio ng-select ou ainda da setagem do set value.
      // Se for a primeira setagem não emit change.
      if (this._value !== v && !this.firstSet) {
        if(Array.isArray(v)) {
          let ids: any[] | null = [];

          v.forEach((v: any) => ids?.push(v.id));

          if(ids.length === 0)
            ids = null;

          this.emitChange?.call(this, ids);
        }
        else {
          if(v !== null)
            this.emitChange?.call(this, (v as any).id);
          else
            this.emitChange?.call(this, null);
        } 
      }

      this._value = v;
      this.firstSet = false;

      return;
    }

    // *************************************************************************
    // Se o datasource já foi inicializado. 
    // *************************************************************************

    // Se v é null, então seta this.value para limpar a seleção e não faz mais nada.
    if (v === null) {
      this.value = v;
      this._idTmp = null;
      return;
    }


    // Se o datasource é uma array, significa que os dados são local, então procura o item adequado.
    if (Array.isArray(this.dataSource)) {
      if(Array.isArray(v)) {
        // Se v é array significa que é multiplos ids.
        let finds: any[] = [];

        for(let i of v) {
          let found = this.dataSource.find((x: any) => x.id === i);

          if(found != null)
            finds.push(found);
        }

        if(finds.length === 0) 
          this.value = null;
        else 
          this.value = finds;
      } else {

        let found = this.dataSource.find((x: any) => x.id === (v as any));

        if(found)
          if(this.multiple)
            this.value = [found];
          else 
            this.value = found;
        else 
          this.value = null;
      }

      this._idTmp = null;
      return;
    }

    //  Se ds está iniciado como remoto, então busca os dados no servidor.
    if (!Array.isArray(this.dataSource) && remoteSearch) {
      let ids: Object[] = [];
      
      if (!Array.isArray(v))
        ids = [v];
      else
        ids = v;

      this._idTmp = v;
      this.defaults.next(ids);
    }
  }

  searchAndSetValue(val: any) {
    //this.log("SEARCH AND SET -> " + val)
    //this.logJson(val)
    // Se o datasource é uma array, significa que os dados são local, então procura o item adequado.
    if (Array.isArray(this.dataSource) && this.mode === SelectMode.ARRAY) {
      if(Array.isArray(val)) {
        // Se val é array significa que é multiplos ids.
        let finds: any[] = [];

        for(let i of val) {
          let found = this.dataSource.find((x: any) => x.id === i.id);

          if(found != null)
            finds.push(found);
        }

        if(finds.length === 0) 
          this.model.get('value')?.setValue(null, { emitEvent: false });
        else 
          this.model.get('value')?.setValue(finds, { emitEvent: false });

      } else {

        let found = this.dataSource.find((x: any) => x.id === (val as any)?.id);

    

        if(found)
          if(this.multiple)
            this.model.get('value')?.setValue([found], { emitEvent: false });
          else 
          this.model.get('value')?.setValue(found, { emitEvent: false });
        else 
          this.model.get('value')?.setValue(null, { emitEvent: false });
      }

      return;
    }
    else if (!Array.isArray(this.dataSource) && this.mode === SelectMode.REMOTE) {
      let ids: Object[] = [];
    
      this.log("SEARCH AND SET REMOTE val");
      this.logJson(val);

      // Se val é null não tem necessidade de buscar nada remotamente.
      if(val === null)
        return;

      if (!Array.isArray(val))
        ids = [val.id];
      else
        ids = val.flatMap((v) => v.id);


      this.defaults.next(ids);
    }
  }

  // FormControl -> Ax-Select
  // Sempre chamada quando vinculado ao FormControl.
  // Para FormControl sem valor, chamado com valor null.
  writeValue(val: any): void {
    this.fromWrite = true;
   

    // Trata undefined como null   
    if (val === undefined)  
      val = null;

    this.val = val;
    
    if(val !== null) {
      if(!Array.isArray(val)) {
        this.model.get('value')?.setValue({ id: val, text: '' }, { emitEvent: false });
      } else {
        let list: any[] = [];
        val.forEach((v) => list.push({ id: v, text: '' }));

        console.log("LIST");
        console.log(list);

        this.model.get('value')?.setValue(list, { emitEvent: false });
      }
    }
    else 
      this.model.get('value')?.setValue(null, { emitEvent: false });

    this.searchAndSetValue(this.model.get('value')?.value);
  }

  registerOnChange(fn: any): void {
    this.emitChange = fn;
  }

  registerOnTouched(fn: any): void {
    //throw new Error("Method not implemented.");
  }

  setDisabledState?(isDisabled: boolean): void {
    //throw new Error("Method not implemented.");
  }

  data(): any | any[] | null {
    return this.model.get('value')?.value;
  }

  filterInput(event: Event) {
    var target = event.target as HTMLInputElement;

    this.ngselect.filter(target.value);
  }

  log(m: Object | null) {
    if(this.debug) {
      console.log(`AX-SELECT: ${m}`)
    }
  }

  logJson(m: Object | null) {
    if(this.debug) {
      console.log(m)
    }
  }
}

















// import { Component, OnInit, Directive, ElementRef, Input, forwardRef, ContentChild, TemplateRef, ViewChild, EventEmitter, Output } from '@angular/core';
// import { Subject, pipe, from, Subscription, throwError } from 'rxjs';
// import { SelectDataSource } from './select-data-source';
// import { HttpClient } from '@angular/common/http';
// import { makeUrl } from 'src/app/utils/global';
// import { tap, switchMap, finalize, catchError, map, delay } from 'rxjs/operators';
// import { SelectQuery } from './select-query';
// import { SelectResult } from './select-result';
// import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
// import { TooltipComponent } from '@syncfusion/ej2-angular-popups';
// import { exception } from 'console';


// @Directive({
//   selector: '[axAutoFocus]'
// })
// export class AxAutoFocusDirective implements OnInit {
//   constructor(private el: ElementRef) { }

//   ngOnInit() {
//     this.el.nativeElement.focus();
//   }

// }

// @Directive({
//   selector: '[axLabelTemplate]'
// })
// export class AxLabelTemplateDirective {
//   constructor() { }
// } 

// @Directive({
//   selector: '[axOptionTemplate]'
// })
// export class AxOptionTemplateDirective {
//   constructor() { }
// } 


// enum SelectMode {
//   ARRAY,
//   REMOTE
// }


// /**
//  * Se dataSource mudar durante a vida útil do componente utilizar o evento onDataSourceConfigured para
//  * setar possível valor padrão, pois não tem como detectar qual sera setado primeiro (o datasouce ou o value) e
//  * o evento onDataSourceConfigured é chamado quando o ds já foi configurado (se o ds é array local a array já terá sido iniciada).
//  * 
//  * Em caso de setar o ds uma vez durante toda a vida útil do componente, então basta alterar o value, para ds remoto o componente
//  * busca o valor no servidor.
//  * 
//  * 
//  */
// @Component({
//   selector: 'ax-select',
//   templateUrl: './ax-select.component.html',
//   styleUrls: ['./ax-select.component.less'],
//   providers: [
//     {
//       provide: NG_VALUE_ACCESSOR,
//       useExisting: forwardRef(() => AxSelectComponent),
//       multi: true,
//     },
//   ],
// })
// export class AxSelectComponent implements OnInit, ControlValueAccessor {
//   @ContentChild(AxLabelTemplateDirective, { read: TemplateRef }) 
//   labelTemplate: TemplateRef<any> = null;
//   @ContentChild(AxOptionTemplateDirective, { read: TemplateRef }) 
//   optionTemplate: TemplateRef<any> = null;

//   dsItems: Object[] = [];

//   private firstSet: boolean = true;

//   private mode: SelectMode | null = null;

//   private init: boolean  = false;

//   hasError: boolean = false;
//   hasMore: boolean = true;
//   loading: boolean = false;
//   firstLoad: boolean = false;
//   loadingDefaults: boolean = false;
//   filter$: Subject<string> = new Subject<string>();
//   defaults: Subject<any> = new Subject<any>();

//   _dataSource: SelectDataSource | any[] = new SelectDataSource();

//   emitChange: any;

//   subDefaults: Subscription = null;
//   subFilter: Subscription = null;

//   // Quando ds ou init ainda não foi inicializado salva o valor em _valueTmp;
//   _idTmp: Object = null;

//   _value: Object = null;

//    tooltipText: string = '';

//   @ViewChild('tooltip')
//   tooltip: TooltipComponent;

//   set value(v: Object) {
//     this.log('SETA VALUE');

//     if(this.loadingDefaults)
//       return;


//     if(v)
//       this.tooltipText = (v as any)?.text ?? '';
//     else 
//       this.tooltipText = '';

//       this.log(v);
//     this.valueChanged(v, false);
//   }

//   get value(): Object {
//     return this._value;
//   }

//   @Output()
//   onDataSourceConfigured: EventEmitter<string> = new EventEmitter<string>();
  
//   @Input()
//   appendTo: string = '';
  
//   @Input() 
//   enabled: boolean = true;
//   @Input() 
//   debug: boolean = false;
//   @Input() 
//   label: string = '';
//   @Input() 
//   id: string = '';
//   @Input() 
//   placeholder: string = '';
//   @Input()
//   clearable: boolean = false;
//   @Input()
//   searchable: boolean = true;

//   _multiple: boolean = false;

//   @Input() 
//   set multiple(v: boolean) {
//     this._multiple = v;

//     if(this.init)
//       this.value = null; 
//   }

//   get multiple(): boolean {
//     return this._multiple;
//   }

//   @Input()
//   set dataSource(v: SelectDataSource | any[]) {

//     this._dataSource = v;
//     this.hasError = false;
//     this.loading = false;
//     this.loadingDefaults = false;

//     if(!v) {
//       return;
//     }

//     if (Array.isArray(v)) {
//       this.mode = SelectMode.ARRAY;
//       this.dsItems = v;
//     } else {
//       this.mode = SelectMode.REMOTE;
//       this.dsItems = [];
//       v.query.page = 0;
//       v.query.term = '';
//     }

//     this.onDataSourceConfigured.next(this.id);

//     if(this.init) {
//       if (this._idTmp !== null) {
//         // _idTmp é sempre o id de um objeto do tipo { id: ... text: ... }, esse objeto pode ter
//         // mais fields opcionais, mas id e text é obrigatório.
//         this.valueChanged(this._idTmp, true);
//         return;
//       }

//       if (this._value !== null) {
//         // _value quando salvo sempre é um objeto do tipo { id: ... text: ... }.
//         this.valueChanged((this._value as any).id, true);
//         return;
//       }
//     }
//   }

//   get dataSource(): SelectDataSource | any[] {
//     return this._dataSource;
//   }

//   constructor(private http: HttpClient) { }
 
//   ex: boolean = false;

//   ngOnInit() {
//     this.init = true;

//     // Configura filter subject.

//     this.subFilter = this.filter$
//       .pipe(
//         tap((term: string) => {
//           this.loading = true;
//           this.hasMore = true;
//         }),
//         switchMap((term: string) => {
//           if (!Array.isArray(this._dataSource)) {

//             let query: SelectQuery<any> = this._dataSource.query;
//             let url: string = this._dataSource.url;

//             query.page = 0;
//             query.term = term;

//             return this.http.post<SelectResult>(url, query, {
//               headers: { ignoreLoadingBar: '' }
//             });

//           } else {
//             return from([{
//               results: this.dsItems.filter((v: Object) => {
//                 return ((v as any).text as string).includes(term);
//               })
//             }
//             ])

//           }

//         }),
//         tap((x: any) => {
//           if (!Array.isArray(this._dataSource)) {
//             this.hasMore = x.pagination.more === true;
//           }
//         }),
//         catchError((err: any) => {
//           if (!Array.isArray(this._dataSource)) {
//             this._dataSource.query.page = 0;
//             this._dataSource.query.term = '';
//           }

//           this.dsItems = [];
//           this.hasError = true;
//           this.hasMore = false;
//           this.loading = false;
          
//           this.log(err);

//           return throwError(err)
//         }),
//         tap(() => {
//           this.loading = false;
//         })
//       )
//       .subscribe((r: SelectResult) => {
//         this.hasError = false;
//         this.dsItems = r.results;
//         this.loading = false;
//       });

//       // Configura defaults subject.

//       this.subDefaults = this.defaults
//       .pipe(
//         tap((ids: any) => {
//           this.loadingDefaults = true;
//           this.loading = true;
//         }),
//         switchMap((ids: any) => {
//           if (!Array.isArray(this._dataSource)) {

//             let query: SelectQuery<any> = this._dataSource.query;
//             let url: string = this._dataSource.url;

//             query.ids = ids;

//             return this.http.post<SelectResult>(url, query, {
//               headers: { ignoreLoadingBar: '' }
//             });
//           } 
//         }),
//         catchError((err: any) => {
//           if (!Array.isArray(this._dataSource)) {
//             this._dataSource.query.page = 0;
//             this._dataSource.query.term = '';
//           }

//           this.dsItems = [];
//           this.hasError = true;
//           this.hasMore = false;
//           this.loading = false;
//           this.loadingDefaults = false;

//           return throwError(err)
//         }),
//         tap(() => {
//           this.loading = false;
//           this.loadingDefaults = false;
//           this._idTmp = null;

//           this.log("VALUE TEP NULLED");

//         })
//       )
//       .subscribe((r: SelectResult) => {
//         if(r.results.length === 0)
//           this.value = null;
//         else {
//           if(!this.multiple) {
//             this.value = r.results[0];
//           }
//           else {
//             this.value = r.results;
//           }
//         }

//         if (this.dsItems.length === 0) {
//           // Se não tem nada carregado ainda, então carrega página 0.
//           this.loadRemoteItems(0);
//         }

//         this.hasError = false;
//       });


//       if (this._idTmp !== null) {
//         // Se tem valor temporario salvo, chanve valueChanged para atualizar value.
//         this.valueChanged(this._idTmp, true);
//         return;
//       }

      
//   }

//   loadRemoteItems(page: number, ids: Object[] = null) {
//     this.loading = true;

//     if (Array.isArray(this._dataSource))
//       return;

//     let query: SelectQuery<any> = this._dataSource.query;
//     let url: string = this._dataSource.url;

//     query.page = page;
//     query.ids = null;

//     this.http.post<SelectResult>(url, query, {
//       headers: { ignoreLoadingBar: '' }
//     })
//       .pipe(
//         tap((x: any) => {
//           this.hasMore = x.pagination.more === true;
//         }),
//         catchError(() => {
//           if (Array.isArray(this._dataSource))
//             return [];

//           this._dataSource.query.page = 0;
//           this._dataSource.query.term = '';
//           this.hasMore = false;
//           this.hasError = true;
//           this.dsItems = [];
//           this.loading = false;

//           return [];
//         }),
//         finalize(() => {
//           this.loading = false;
//         })
//       )
//       .subscribe((r: SelectResult) => {

//         this.dsItems = this.dsItems.concat(r.results);
//         this.loading = false;
//         this.hasError = false;

//         this.log("LOADED");
//       });
//   }

//   onScrollToEnd() {

//     if (!this.hasMore || this.mode === SelectMode.ARRAY)
//       return;

//     if (!Array.isArray(this._dataSource)) {
//       this._dataSource.query.page += 1;
//       this.loadRemoteItems(this._dataSource.query.page);
//     }
//   }

//   onScroll({ end }) {
//     if (this.loading || !this.hasMore || this.mode === SelectMode.ARRAY)
//       return;

//     if ((end) >= (this.dsItems.length - 250 - 1)) {
//       if (!Array.isArray(this._dataSource)) {
//         this._dataSource.query.page += 1;
//         this.loadRemoteItems(this._dataSource.query.page);
//       }
//     }
//   }

//   onOpen() {
//     if (this.hasError) {
//       // Se está marcado que ocorreu algum erro
//       // reinicia componente.

//       if(this.subDefaults)
//         this.subDefaults.unsubscribe();

//         if(this.subFilter)
//         this.subFilter.unsubscribe();

//       this.defaults = new Subject<any>();
//       this.filter$ = new Subject<string>();

//       this.ngOnInit();

//       if(this._idTmp === null) {
//         this.loadRemoteItems(0);
//       }
//     } else {
//       if(this.dsItems.length === 0 && !Array.isArray(this.dataSource)) {
//         this.loadRemoteItems(0);
//       }
//     }

//   }

//   valueChanged(v: Object, remoteSearch: boolean): void {
//     this.log("valueChanged = " + v);

//     // Se datasource esta null ou init ainda nao cocorreu, não faz nenhuma alteração no value, espera até ser inicializado.
//     if (this.dataSource == null || this.init === false) {
//       // Salva tmp para quando datasource for inicializado.
//       this._idTmp = v;
//       return;
//     }

//     if (!remoteSearch) {

//       if(this.fromWrite) {
//         // Se from write não emite change.
//         this._value = v;
//         this.firstSet = false;
//         this.fromWrite = false;
//         return;
//       }

//       // Se a setagem esta vindo do próprio ng-select ou ainda da setagem do set value.
//       // Se for a primeira setagem não emit change.
//       if (this._value !== v && !this.firstSet) {
//         if(Array.isArray(v)) {
//           let ids: any[] = [];

//           v.forEach((v: any) => ids.push(v.id));

//           if(ids.length === 0)
//             ids = null;

//           this.emitChange?.call(this, ids);
//         }
//         else {
//           if(v !== null)
//             this.emitChange?.call(this, (v as any).id);
//           else
//             this.emitChange?.call(this, null);
//         } 
//       }

//       this._value = v;
//       this.firstSet = false;

//       return;
//     }

//     // *************************************************************************
//     // Se o datasource já foi inicializado. 
//     // *************************************************************************

//     // Se v é null, então seta this.value para limpar a seleção e não faz mais nada.
//     if (v === null) {
//       this.value = v;
//       this._idTmp = null;
//       return;
//     }


//     // Se o datasource é uma array, significa que os dados são local, então procura o item adequado.
//     if (Array.isArray(this.dataSource)) {
//       if(Array.isArray(v)) {
//         // Se v é array significa que é multiplos ids.
//         let finds: any[] = [];

//         for(let i of v) {
//           let found = this.dataSource.find((x: any) => x.id === i);

//           if(found != null)
//             finds.push(found);
//         }

//         if(finds.length === 0) 
//           this.value = null;
//         else 
//           this.value = finds;
//       } else {

//         let found = this.dataSource.find((x: any) => x.id === (v as any));

//         if(found)
//           if(this.multiple)
//             this.value = [found];
//           else 
//             this.value = found;
//         else 
//           this.value = null;
//       }

//       this._idTmp = null;
//       return;
//     }

//     //  Se ds está iniciado como remoto, então busca os dados no servidor.
//     if (!Array.isArray(this.dataSource) && remoteSearch) {
//       let ids: Object[] = [];
      
//       if (!Array.isArray(v))
//         ids = [v];
//       else
//         ids = v;

//       this._idTmp = v;
//       this.defaults.next(ids);
//     }
//   }

//   fromWrite: boolean = false;

//   // FormControl -> Ax-Select
//   // Sempre chamada quando vinculado ao FormControl.
//   // Para FormControl sem valor, chamado com valor null.
//   writeValue(obj: any): void {
//     this.fromWrite = true;

//     this.log("WRITE VALUE");
//     this.log(obj);

//     // Trata undefined como null   
//     if (obj === undefined)  
//       obj = null;

//     this.valueChanged(obj, true);
//   }

//   registerOnChange(fn: any): void {
//     this.emitChange = fn;
//   }

//   registerOnTouched(fn: any): void {
//     //throw new Error("Method not implemented.");
//   }

//   setDisabledState?(isDisabled: boolean): void {
//     //throw new Error("Method not implemented.");
//   }

//   log(m: Object) {
//     if(this.debug) {
//       console.log(`AX-SELECT: ${m}`)
//     }
//   }
// }
